"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.gql = void 0;
/* eslint-disable */
const types = __importStar(require("./graphq-only-used-exports"));
/**
 * Map of all GraphQL operations in the project.
 *
 * This map has several performance disadvantages:
 * 1. It is not tree-shakeable, so it will include all operations in the project.
 * 2. It is not minifiable, so the string of a GraphQL query will be multiple times inside the bundle.
 * 3. It does not support dead code elimination, so it will add unused operations.
 *
 * Therefore it is highly recommended to use the babel or swc plugin for production.
 */
const documents = {
    "\n    mutation AdvertiserLogAskemEvent($input: LogAskemEventInput!) {\n        advertiserLogAskemEvent(input: $input) {\n            wasSuccessful\n            uid\n        }\n    }\n": types.AdvertiserLogAskemEventDocument,
    "\n    mutation AuthenticatedLogAskemEvent($input: LogAskemEventInput!) {\n        authenticatedLogAskemEvent(input: $input) {\n            wasSuccessful\n            uid\n        }\n    }\n": types.AuthenticatedLogAskemEventDocument,
};
function gql(source) {
    var _a;
    return (_a = documents[source]) !== null && _a !== void 0 ? _a : {};
}
exports.gql = gql;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ3FsLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL19fZ2VuZXJhdGVkX18vZ3FsLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsb0JBQW9CO0FBQ3BCLGtFQUFvRDtBQUdwRDs7Ozs7Ozs7O0dBU0c7QUFDSCxNQUFNLFNBQVMsR0FBRztJQUNkLHlMQUF5TCxFQUFFLEtBQUssQ0FBQywrQkFBK0I7SUFDaE8sK0xBQStMLEVBQUUsS0FBSyxDQUFDLGtDQUFrQztDQUM1TyxDQUFDO0FBeUJGLFNBQWdCLEdBQUcsQ0FBQyxNQUFjOztJQUNoQyxPQUFPLE1BQUMsU0FBaUIsQ0FBQyxNQUFNLENBQUMsbUNBQUksRUFBRSxDQUFDO0FBQzFDLENBQUM7QUFGRCxrQkFFQyJ9